// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewMessages__container-b7e9f7 {
  flex: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 14px auto 2px;
  align-self: center;
  width: 100%;
}

.NewMessages__text-b19717 {
  white-space: nowrap;
  padding: 6px 12px;
  margin: auto;
  background: var(--average-background);
  color: var(--text-on-background);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  width: 100%;
  text-align: center;
  line-height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/NewMessages/NewMessages.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,qCAAA;EACA,gCAAA;EACA,4BAAA;EACA,8CAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AACF","sourcesContent":[".container {\n  flex: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 14px auto 2px;\n  align-self: center;\n  width: 100%;\n}\n\n.text {\n  white-space: nowrap;\n  padding: 6px 12px;\n  margin: auto;\n  background: var(--average-background);\n  color: var(--text-on-background);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  width: 100%;\n  text-align: center;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewMessages__container-b7e9f7`,
	"text": `NewMessages__text-b19717`
};
module.exports = ___CSS_LOADER_EXPORT___;
